import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";
import { romeToday, shiftDay, longDate } from "./agendaConfig";

export default function AgendaDateNav({ date, onChange }) {
  const inputRef = useRef(null);
  const isToday = date === romeToday();
  const navBtn = "w-11 h-11 rounded-full border border-sand-300 bg-white flex items-center justify-center " +
    "hover:border-bronze-400 active:scale-95 transition-[transform,border-color]";
  return (
    <div className="flex items-center gap-2" data-testid="agenda-date-nav">
      <button type="button" className={navBtn} onClick={() => onChange(shiftDay(date, -1))}
              aria-label="Giorno precedente" data-testid="agenda-prev-day">
        <ChevronLeft className="w-5 h-5" />
      </button>
      <label className="relative flex-1 min-w-0 h-11 rounded-full border border-sand-300 bg-white px-4
                        flex items-center gap-2 cursor-pointer hover:border-bronze-400 transition-colors"
             data-testid="agenda-date-picker">
        <CalendarDays className="w-4 h-4 text-bronze-600 shrink-0" />
        <span className="truncate text-sm font-medium text-ink-900 capitalize" data-testid="agenda-selected-date">
          {longDate(date)}
        </span>
        <input ref={inputRef} type="date" value={date} aria-label="Scegli data"
               onChange={(e) => e.target.value && onChange(e.target.value)}
               className="absolute inset-0 opacity-0 w-full h-full cursor-pointer" data-testid="agenda-date-input" />
      </label>
      <button type="button" className={navBtn} onClick={() => onChange(shiftDay(date, 1))}
              aria-label="Giorno successivo" data-testid="agenda-next-day">
        <ChevronRight className="w-5 h-5" />
      </button>
      <button type="button" onClick={() => onChange(romeToday())} disabled={isToday}
              data-testid="agenda-today-btn"
              className={`h-11 px-4 rounded-full text-sm font-medium transition-colors ${
                isToday ? "bg-sand-200 text-ink-500" : "bg-ink-900 text-white hover:bg-ink-700"}`}>
        Oggi
      </button>
    </div>
  );
}
